// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-images-container[data-v-4dea868d]{max-width:1200px;margin-left:auto;margin-right:auto}.form-images-container img[data-v-4dea868d]{-o-object-fit:cover;object-fit:cover;aspect-ratio:1/1}@media(min-width:992px){.form-images-container img[data-v-4dea868d]{aspect-ratio:none;max-height:15rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
